import { Component, OnInit } from '@angular/core';
import { DataService } from '../../core/services/data.service';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { DomSanitizer } from '@angular/platform-browser';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-log',
  templateUrl: './log.component.html',
  styleUrls: ['./log.component.scss'],
})
export class LogComponent implements OnInit {
  logFiles: string[] = [];
  selectLog: string;
  logContent: string[] = [];
  cacheLogs: boolean = false;
  fileUrl;

  constructor(
    private dataService: DataService,
    private sanitizer: DomSanitizer,
    private _snackBar: MatSnackBar
  ) {}

  /**
   * Retrieves logs from the data service.
   */
  ngOnInit(): void {
    this.dataService.getLogs().subscribe({
      next: (data) => {
        var logList = data.reverse();
        this.logFiles = logList;
      },
    });
  }

  /**
   * Handles changes to the cache checkbox.
   * @param value The checked state of the cache checkbox.
   */
  loadCacheLogs(value: MatCheckboxChange) {
    if (value.checked) {
      this.dataService.getCacheLogs().subscribe({
        next: (data) => {
          var logList = data.reverse();
          this.logFiles = logList;
          if (this.logFiles === null) {
            this._snackBar.open($localize`Cache List is empty`);
          }
        },
      });
    } else {
      this.dataService.getLogs().subscribe({
        next: (data) => {
          var logList = data.reverse();
          this.logFiles = logList;
        },
      });
    }

    this.cacheLogs = value.checked;
  }

  /**
   * Handles changes to the selected log.
   */
  selectedLog() {
    if (this.selectLog !== undefined && !this.cacheLogs) {
      this.getInfoLogs();
    } else if (this.selectLog !== undefined && this.cacheLogs) {
      this.getCacheLogs();
    }
  }

  /**
   * Retrieves logs for the selected log file from the data service.
   */
  getInfoLogs() {
    this.dataService.readLogs(this.selectLog).subscribe({
      next: (data) => {
        this.logContent = data;
        var setting = JSON.stringify(data, null, ' ');
        const blob = new Blob([setting], { type: 'application/json' });
        this.fileUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
          window.URL.createObjectURL(blob)
        );
      },
    });
  }

  /**
   * Retrieves cache logs for the selected log file from the data service.
   */
  getCacheLogs() {
    this.dataService.readCacheLogs(this.selectLog).subscribe({
      next: (data) => {
        this.logContent = data;
        var setting = JSON.stringify(data, null, ' ');
        const blob = new Blob([setting], { type: 'application/json' });
        this.fileUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
          window.URL.createObjectURL(blob)
        );
      },
    });
  }
}
